// extracted by mini-css-extract-plugin
export default {"container":"TabMenu_container__XDSsQ"};